import classNames from "classnames";
import { useNavigate } from "react-router-dom";
import { Toolbar, AppBar as MaterialAppBar, Typography, IconButton, Box } from "@mui/material";
import { mdiArrowLeft } from "@mdi/js";

import useBoundStore from "store";
import logo from "assets/icons/logo.svg?url";
import ContrastIcon from "../ContrastIcon";

export interface AppBarProps {
  actions?: Array<React.ReactElement>;
  backAction?: boolean;
  noRadius?: boolean;
  showLogo?: boolean;
  title?: string;
  onBack?: () => void;
}

function AppBar(props: AppBarProps) {
  const { actions, backAction = true, noRadius = false, showLogo = false, title, onBack } = props;
  const navigate = useNavigate();
  const isMobileDevice = useBoundStore((state) => state.miscellaneous.isMobileDevice);

  const handleBackClick = (e: any) => {
    e.stopPropagation();
    if (onBack) {
      onBack();
    } else {
      navigate(-1);
    }
  };

  return (
    <>
      <MaterialAppBar
        elevation={isMobileDevice ? 4 : 1}
        position={isMobileDevice ? "fixed" : "static"}
        sx={{
          ...(isMobileDevice || noRadius ? {} : { borderTopLeftRadius: 24, borderTopRightRadius: 24 }),
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
          <Box alignItems='center' display='flex' minWidth={0}>
            {backAction && (
              <IconButton aria-label='Go back' sx={{ mr: 1 }} onClick={handleBackClick} size='large'>
                <ContrastIcon path={mdiArrowLeft} size={0.8} />
              </IconButton>
            )}
            {showLogo && <img alt='GroupUp logo' src={logo} style={{ height: 42, marginRight: 8 }} />}
            <Typography overflow='hidden' textOverflow='ellipsis' variant='h6' whiteSpace='nowrap'>
              {title}
            </Typography>
          </Box>
          {actions ? (
            <Box alignItems='center' display='flex'>
              {actions.map((action) => (
                <div className={classNames(action.props.className)} key={action.key}>
                  {action}
                </div>
              ))}
            </Box>
          ) : null}
        </Toolbar>
      </MaterialAppBar>
      {isMobileDevice && <Toolbar />}
    </>
  );
}

export default AppBar;
